(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mvm-cinema-hero')) {
    customElements.define('mvm-cinema-hero', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.visible = false;
        this.sync = () => {
          if (this.visible && !document.hidden && !this.motion.matches && this.dataset.autoplay === 'true') {
            this.video.play().catch(() => {});
          } else {
            this.video.pause();
          }
        };
        this.playing = () => this.setAttribute('data-playing', '');
        this.video.addEventListener('playing', this.playing);
        this.motion.addEventListener('change', this.sync);
        document.addEventListener('visibilitychange', this.sync);
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.sync();
        }, { threshold: 0.05 });
        this.observer.observe(this);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.motion?.removeEventListener('change', this.sync);
        document.removeEventListener('visibilitychange', this.sync);
        this.video?.removeEventListener('playing', this.playing);
        this.video?.pause();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mvm-community-event"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mvm-event-requests')) {
    customElements.define('mvm-event-requests', class extends HTMLElement {
      connectedCallback() {
        this.cleanup?.abort();
        this.cleanup = new AbortController();
        const options = { signal: this.cleanup.signal };
        this.list = this.querySelector('[data-event-list]');
        this.intro = this.querySelector('[data-intro]');
        this.panel = this.querySelector('[data-panel]');
        this.back = this.querySelector('[data-back]');
        this.select = this.querySelector('[data-event-select]');
        this.back.hidden = false;
        const result = this.querySelector('[data-success], [data-errors]');
        const syncIntro = () => {
          const selectedId = this.select?.selectedOptions[0]?.dataset.eventId;
          this.querySelectorAll('[data-event-intro]').forEach(intro => {
            intro.hidden = intro.dataset.eventIntro !== selectedId;
          });
        };
        const show = (formVisible, focus = true) => {
          this.panel.hidden = !formVisible;
          this.list.hidden = formVisible;
          this.intro.hidden = formVisible;
          if (focus) (formVisible ? this.querySelector('[data-form-heading], [data-success], [data-errors]') : this.lastLink)?.focus();
        };
        syncIntro();
        this.select?.addEventListener('change', syncIntro, options);
        show(Boolean(result) || location.hash === '#' + this.panel.id, false);
        if (result) result.focus();
        this.querySelectorAll('[data-select-event]').forEach(link => link.addEventListener('click', event => {
          if (!this.select) return;
          event.preventDefault();
          this.lastLink = link;
          const selected = Array.from(this.select.options).find(option => option.dataset.eventId === link.dataset.selectEvent);
          if (!selected) return;
          this.select.value = selected.value;
          syncIntro();
          show(true);
          history.pushState(null, '', '#' + this.panel.id);
          this.panel.scrollIntoView({ block: 'start' });
        }, options));
        this.back.addEventListener('click', () => {
          if (this.querySelector('[data-success]')) {
            const target = new URL(location.href);
            target.searchParams.delete('contact_posted');
            target.hash = '';
            location.assign(target.href);
            return;
          }
          show(false);
          history.replaceState(null, '', location.pathname + location.search);
        }, options);
        window.addEventListener('popstate', () => show(Boolean(result) || location.hash === '#' + this.panel.id, false), options);
        window.addEventListener('hashchange', () => show(Boolean(result) || location.hash === '#' + this.panel.id, false), options);
        this.addEventListener('shopify:block:select', () => show(false, false), options);
      }
      disconnectedCallback() { this.cleanup?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mvm-events-registration"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mvm-event-requests')) {
    customElements.define('mvm-event-requests', class extends HTMLElement {
      connectedCallback() {
        this.cleanup?.abort();
        this.cleanup = new AbortController();
        const options = { signal: this.cleanup.signal };
        this.list = this.querySelector('[data-event-list]');
        this.intro = this.querySelector('[data-intro]');
        this.panel = this.querySelector('[data-panel]');
        this.back = this.querySelector('[data-back]');
        this.select = this.querySelector('[data-event-select]');
        this.back.hidden = false;
        const result = this.querySelector('[data-success], [data-errors]');
        const syncIntro = () => {
          const selectedId = this.select?.selectedOptions[0]?.dataset.eventId;
          this.querySelectorAll('[data-event-intro]').forEach(intro => {
            intro.hidden = intro.dataset.eventIntro !== selectedId;
          });
        };
        const show = (formVisible, focus = true) => {
          this.panel.hidden = !formVisible;
          this.list.hidden = formVisible;
          this.intro.hidden = formVisible;
          if (focus) (formVisible ? this.querySelector('[data-form-heading], [data-success], [data-errors]') : this.lastLink)?.focus();
        };
        syncIntro();
        this.select?.addEventListener('change', syncIntro, options);
        show(Boolean(result) || location.hash === '#' + this.panel.id, false);
        if (result) result.focus();
        this.querySelectorAll('[data-select-event]').forEach(link => link.addEventListener('click', event => {
          if (!this.select) return;
          event.preventDefault();
          this.lastLink = link;
          const selected = Array.from(this.select.options).find(option => option.dataset.eventId === link.dataset.selectEvent);
          if (!selected) return;
          this.select.value = selected.value;
          syncIntro();
          show(true);
          history.pushState(null, '', '#' + this.panel.id);
          this.panel.scrollIntoView({ block: 'start' });
        }, options));
        this.back.addEventListener('click', () => {
          if (this.querySelector('[data-success]')) {
            const target = new URL(location.href);
            target.searchParams.delete('contact_posted');
            target.hash = '';
            location.assign(target.href);
            return;
          }
          show(false);
          history.replaceState(null, '', location.pathname + location.search);
        }, options);
        window.addEventListener('popstate', () => show(Boolean(result) || location.hash === '#' + this.panel.id, false), options);
        window.addEventListener('hashchange', () => show(Boolean(result) || location.hash === '#' + this.panel.id, false), options);
        this.addEventListener('shopify:block:select', () => show(false, false), options);
      }
      disconnectedCallback() { this.cleanup?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mvm-hero-cinema"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mvm-cinema-hero')) {
    customElements.define('mvm-cinema-hero', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.visible = false;
        this.sync = () => {
          if (this.visible && !document.hidden && !this.motion.matches && this.dataset.autoplay === 'true') {
            this.video.play().catch(() => {});
          } else {
            this.video.pause();
          }
        };
        this.playing = () => this.setAttribute('data-playing', '');
        this.video.addEventListener('playing', this.playing);
        this.motion.addEventListener('change', this.sync);
        document.addEventListener('visibilitychange', this.sync);
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.sync();
        }, { threshold: 0.05 });
        this.observer.observe(this);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.motion?.removeEventListener('change', this.sync);
        document.removeEventListener('visibilitychange', this.sync);
        this.video?.removeEventListener('playing', this.playing);
        this.video?.pause();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mvm-main-product"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('m2-product'))customElements.define('m2-product',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;this.addEventListener('change',e=>{if(e.target.matches('[data-option]'))this.changeVariant(e.target.dataset.option);});}
async changeVariant(position){
this.request?.abort();const request=new AbortController();this.request=request;
const options=[...this.querySelectorAll('[data-option]')].map(el=>el.value).join(',');
const button=this.querySelector('[name=add]'),variant=this.querySelector('[name=id]');button.disabled=true;variant.disabled=true;
const status=this.querySelector('[role=status]');status.textContent=this.dataset.updating;
try{
const url=new URL(this.dataset.url,location.origin);url.searchParams.set('section_id',this.dataset.section);url.searchParams.set('option_values',options);
const response=await fetch(url,{signal:request.signal});if(!response.ok)throw new Error('Selection failed');
const doc=new DOMParser().parseFromString(await response.text(),'text/html');const fresh=doc.querySelector('m2-product [data-content]');if(!fresh)throw new Error('Missing product');
if(request.signal.aborted)return;
this.querySelector('[data-content]').replaceWith(fresh);status.textContent='';
const selected=this.querySelector('[name=id]').value;const nextURL=new URL(location.href);nextURL.searchParams.delete('variant');nextURL.searchParams.delete('option_values');if(selected)nextURL.searchParams.set('variant',selected);else nextURL.searchParams.set('option_values',options);history.replaceState({},'',nextURL);
this.querySelector('[data-option="'+position+'"]')?.focus({preventScroll:true});
}catch(e){if(e.name!=='AbortError')status.textContent=this.dataset.error;}
}
disconnectedCallback(){this.request?.abort();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mvmcinemawhite"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mvm-cinema-hero')) {
    customElements.define('mvm-cinema-hero', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.visible = false;
        this.sync = () => {
          if (this.visible && !document.hidden && !this.motion.matches && this.dataset.autoplay === 'true') {
            this.video.play().catch(() => {});
          } else {
            this.video.pause();
          }
        };
        this.playing = () => this.setAttribute('data-playing', '');
        this.video.addEventListener('playing', this.playing);
        this.motion.addEventListener('change', this.sync);
        document.addEventListener('visibilitychange', this.sync);
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.sync();
        }, { threshold: 0.05 });
        this.observer.observe(this);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.motion?.removeEventListener('change', this.sync);
        document.removeEventListener('visibilitychange', this.sync);
        this.video?.removeEventListener('playing', this.playing);
        this.video?.pause();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mvmregistration"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mvm-event-requests')) {
    customElements.define('mvm-event-requests', class extends HTMLElement {
      connectedCallback() {
        this.cleanup?.abort();
        this.cleanup = new AbortController();
        const options = { signal: this.cleanup.signal };
        this.list = this.querySelector('[data-event-list]');
        this.intro = this.querySelector('[data-intro]');
        this.panel = this.querySelector('[data-panel]');
        this.back = this.querySelector('[data-back]');
        this.select = this.querySelector('[data-event-select]');
        this.back.hidden = false;
        const result = this.querySelector('[data-success], [data-errors]');
        const show = (formVisible, focus = true) => {
          this.panel.hidden = !formVisible;
          this.list.hidden = formVisible;
          this.intro.hidden = formVisible;
          if (focus) (formVisible ? this.querySelector('[data-form-heading], [data-success], [data-errors]') : this.lastLink)?.focus();
        };
        show(Boolean(result) || location.hash === '#' + this.panel.id, false);
        if (result) result.focus();
        this.querySelectorAll('[data-select-event]').forEach(link => link.addEventListener('click', event => {
          if (!this.select) return;
          event.preventDefault();
          this.lastLink = link;
          const selected = Array.from(this.select.options).find(option => option.dataset.eventId === link.dataset.selectEvent);
          if (!selected) return;
          this.select.value = selected.value;
          show(true);
          history.pushState(null, '', '#' + this.panel.id);
          this.panel.scrollIntoView({ block: 'start' });
        }, options));
        this.back.addEventListener('click', () => {
          if (this.querySelector('[data-success]')) {
            const target = new URL(location.href);
            target.searchParams.delete('contact_posted');
            target.hash = '';
            location.assign(target.href);
            return;
          }
          show(false);
          history.replaceState(null, '', location.pathname + location.search);
        }, options);
        window.addEventListener('popstate', () => show(location.hash === '#' + this.panel.id, false), options);
        this.addEventListener('shopify:block:select', () => show(false, false), options);
      }
      disconnectedCallback() { this.cleanup?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
